import WithdrawCoinbase from './CoinbasePay'

export default WithdrawCoinbase
